
import React, { useState, useEffect } from 'react';
import '../css/dataTablePopUp.css';

const SortPopupComponent = ({ onClose, onRemoveTable, nodeName, selectedNodeId, onValueSubmit,
  nodes, setNodes,edges,setEdges, droppedNodes, setDroppedNodes, data, selectedPreviousTable, catalog, selectedDatabase,
  selectedCurrentTableValue, firstColumn,
  columns, isCheckedValue, thenByIsCheckedValue,
  selectedThenByColumnValue, showAdditionalinputlength, aliasColumn, connectionType
}) => {
  console.log(JSON.stringify(aliasColumn) + "aliasColumn");
  // alert(JSON.stringify(selectedCurrentTableValue)+"selectedCurrentTableValue");
  // alert(JSON.stringify(selectedDatabase.name)+"---"+JSON.stringify(selectedCurrentTableValue.name));
  console.log(JSON.stringify(selectedPreviousTable) + "selectedPreviousTable");
  console.log(JSON.stringify(showAdditionalinputlength) + "showAdditionalInputs.length");
  console.log(JSON.stringify(selectedCurrentTableValue) + "selectedCurrentTableValue");
  console.log(JSON.stringify(firstColumn) + "firstColumn");
  console.log(JSON.stringify(columns) + "columns[]0");
  console.log(JSON.stringify(catalog) + "catalog");
  console.log(JSON.stringify(selectedDatabase) + "selectedDatabase");
  console.log(JSON.stringify(selectedCurrentTableValue) + "selectedCurrentTableValue0");

  let columnsDataValues;


  if (columns && columns.length > 1) {
    columnsDataValues = [].concat(...columns);
  } else {
    columnsDataValues = columns[0];
  }
  console.log(JSON.stringify(columnsDataValues) + "columnsDataValues");

  const [isChecked, setIsChecked] = useState(isCheckedValue || false);
  const [thenByIsChecked, setThenByIsChecked] = useState(thenByIsCheckedValue || false);
  const [selectedColumns, setSelectedColumns] = useState(
    firstColumn !== undefined ? firstColumn : columnsDataValues[0]
  );
  const [selectedThenByColumns, setSelectedThenByColumns] = useState(
    selectedThenByColumnValue.length > 0 ? selectedThenByColumnValue : ['']
  );
  // const [selectedThenByColumns, setSelectedThenByColumns] = useState([selectedThenByColumnValue]);
  const [showAdditionalInputs, setShowAdditionalInputs] = useState([]);


  const [name, setName] = useState(nodeName);


  function currentAndPreviousTablesAreEqual(previouseTable, currentTable) {

    // Check if both tables are undefined
    if (previouseTable === undefined && currentTable === undefined) {
      return true;
    }

    // Check if one of the tables is undefined and the other is not
    if (previouseTable === undefined || currentTable === undefined) {
      return false;
    }
    if (previouseTable.length !== currentTable.length) {
      return false;
    }

    for (let i = 0; i < currentTable.length; i++) {
      if (previouseTable[i] !== currentTable[i]) {
        return false;
      }
    }

    return true;
  }



  useEffect(() => {
    setName(nodeName);
    setSelectedColumns(selectedColumns);
    setIsChecked(isChecked);
    setThenByIsChecked(thenByIsCheckedValue);
    setSelectedThenByColumns(selectedThenByColumnValue);



    if (currentAndPreviousTablesAreEqual(selectedPreviousTable, selectedCurrentTableValue)) {

      setShowAdditionalInputs(showAdditionalinputlength > 0 ? [{}] : []);
      setSelectedColumns(selectedColumns);
    } else {
      // current table and previous tables are not equal
      setShowAdditionalInputs([]);
      setSelectedThenByColumns([]);
      setIsChecked(false);
      setThenByIsChecked(false);

    }

  }, [nodeName, selectedCurrentTableValue, selectedPreviousTable, selectedColumns, isChecked, thenByIsCheckedValue, selectedThenByColumnValue, showAdditionalinputlength]
  );



  const renderAdditionalInputs = () => {
    if (showAdditionalInputs.length > 0) {
      return selectedThenByColumns.map((column, index) => (
        <div key={index}>
          {/* Render your additional inputs here */}
          <div className="form-group">
            <label htmlFor={`dropdown-${index}`}>Sort By</label>
            <select
              id={`dropdown-${index}`}
              className="form-control"
              value={selectedThenByColumns[index]}
              onChange={(event) => handleThenByColumnChange(event, index)}
            >
              {renderColumnOptions()}
            </select>
          </div>
          <div className="checkbox-container">
            <label>
              <input
                type="checkbox"
                checked={thenByIsChecked[index]}
                onChange={(event) => handleThenByCheckboxChange(event, index)}
              />
              Descending
            </label>
          </div>
          <div className="form-group">
            <button
              id="addanother"
              type="button"
              className="btn btn-warning"
              onClick={() => handleRemoveClick(index)}
            >
              Remove
            </button>
          </div>
        </div>
      ));
    }
    return null;
  };

  const handleAddAnotherClick = () => {
    const newSelectedThenByColumns = [...selectedThenByColumns, columnsDataValues[0]];
    const newSetThenByIsChecked = [thenByIsChecked, false];

    console.log(JSON.stringify(newSelectedThenByColumns) + "---" +
      JSON.stringify(newSetThenByIsChecked));
    setSelectedThenByColumns(newSelectedThenByColumns);
    setThenByIsChecked(newSetThenByIsChecked);


    setSelectedThenByColumns(selectedThenByColumns => [...selectedThenByColumns]);
    setThenByIsChecked(thenByIsChecked => [...thenByIsChecked]);
    // setSelectedThenByColumns([...selectedThenByColumns, '']);
    setShowAdditionalInputs([...showAdditionalInputs, {}]);
  };

  const handleRemoveClick = (index) => {
    setSelectedThenByColumns((prevColumns) => {
      const updatedColumns = [...prevColumns];
      updatedColumns.splice(index, 1);
      return updatedColumns;
    });
  };


  const handleRemoveTable = () => {
    // Call the onRemoveTable callback function
    var newNodes = []
    var newEdges = []
    var newDroppedNodes = []
    //console.log("onRemoveTable::1", nodes[0]["id"], selectedNodeId)
    if (onRemoveTable) {
      newNodes = nodes.filter((node) => node["id"] != selectedNodeId);
      newEdges = edges.filter((edge) => !edge["id"].includes(`-${selectedNodeId}`));
      //edataTable_1-
      for (let i = 0; i < droppedNodes.length; i++) {
        if (droppedNodes[i] === selectedNodeId) {
          droppedNodes.splice(i, 1);
          console.log("Remaining elements: " + droppedNodes);
        }
      }
      //newDroppedNodes = droppedNodes.filter(!selectedNodeId)
      console.log("onRemoveTable::2", newNodes, selectedNodeId, edges, newEdges, newDroppedNodes)
      onRemoveTable();
    }
    // Close the popup
    setNodes(newNodes)
    setEdges(newEdges)
    setDroppedNodes(droppedNodes)
    //onClose(nodes)
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(JSON.stringify(aliasColumn) + "aliasColumn");
    console.log(JSON.stringify(firstColumn) + "firstColumn");
    console.log("selectedColumns",JSON.stringify(selectedColumns));
    let selectedSortColumnsAppend;
    if (aliasColumn && Array.isArray(aliasColumn) && aliasColumn.some(item => item == selectedColumns)) {
      // If aliasColumn is an array and all its elements are present in selectedColumns
      selectedSortColumnsAppend = selectedColumns;

    } else {

      // Use a loop to check each array in `columns`
      for (let i = 0; i < columns.length; i++) {
        if (columns[i].some(column => selectedColumns.includes(column))) {
          if (connectionType !== 'SQLite') {
            if (connectionType = 'kafka') {
              const col_part = selectedColumns.split('_message_')
              let selectedColumnsKafka = 'json_extract_scalar(' + col_part[0] + '_message,' + "'$." + col_part[1] + "')" 
              //+ '_message_' + col_part[1];
              selectedSortColumnsAppend = selectedColumnsKafka;
              console.log("sortelectedColumns::1", selectedColumnsKafka)
            } else {
            // Use values from the current array
            selectedSortColumnsAppend = selectedColumns;
            console.log("sortelectedColumns::2",JSON.stringify(selectedSortColumnsAppend));
          }
          } else {

            const parts = selectedColumns.split('.');
            let displayValue = selectedColumns;

            if (parts.length === 4) {
              displayValue = parts.slice(2).join('.');
            } else if (parts.length === 2) {
              displayValue = selectedColumns;
            } else {
              displayValue = selectedColumns;
            }

            // Use values from the current array
            selectedSortColumnsAppend = displayValue;
            console.log(JSON.stringify(selectedSortColumnsAppend) + "selectedSortColumnsAppend");

          }

          break; // Exit the loop when a match is found
        }
      }

      // If no match is found, use values directly
      if (!selectedSortColumnsAppend) {
        selectedSortColumnsAppend = `${selectedColumns}`;
      }

    }

    let selectedThenByColumnsAppend;
    if (aliasColumn && Array.isArray(aliasColumn) && aliasColumn.some(item => item == selectedThenByColumns)) {
      selectedThenByColumnsAppend = selectedThenByColumns;
    } else {


      // Use a loop to check each array in `columns`
      for (let i = 0; i < columns.length; i++) {
        if (columns[i].some(column => selectedColumns.includes(column))) {
          if (connectionType !== 'SQLite') {
            // Use values from the current array
            selectedThenByColumnsAppend = selectedThenByColumns.map((column) => column);

            console.log("sortelectedColumns::3",JSON.stringify(selectedSortColumnsAppend));
          } else {
            // Use values from the current array
            selectedThenByColumnsAppend = selectedThenByColumns.map((column) => {

              const parts = column.split('.');
              let displayValue = column;

              if (parts.length === 4) {
                displayValue = parts.slice(2).join('.');
              }

              return displayValue;
            });
            console.log(JSON.stringify(selectedThenByColumnsAppend) + "selectedSortColumnsAppend");
          }

          break; // Exit the loop when a match is found
        }
      }

      // If no match is found, use values directly
      if (!selectedSortColumnsAppend) {
        selectedThenByColumnsAppend = selectedThenByColumns.map((column) => column);
      }


    }
    if (connectionType === 'kafka') { // Correcting '=' to '===' for comparison
      selectedThenByColumnsAppend.forEach((col, index) => {
        const parts = col.split('_message_');
        if (parts.length === 2) {
          // Transform the column using the required format
          selectedThenByColumnsAppend[index] = `json_extract_scalar(${parts[0]}_message, '$.${parts[1]}')`;
        }
      });
    }
    console.log(JSON.stringify(selectedSortColumnsAppend) + "selectedSortColumnsAppend");
    console.log(JSON.stringify(selectedThenByColumnsAppend) + "selectedThenByColumnsAppend");


    //  firstColumn = selectedColumns;
    let buildOrderBy;
    buildOrderBy = selectedSortColumnsAppend;
    const showAdditionalinputlength = showAdditionalInputs.length;


    buildOrderBy += isChecked ? ' DESC' : '';

    if (selectedThenByColumnsAppend && selectedThenByColumnsAppend.length > 0) {
      buildOrderBy += ',' + selectedThenByColumnsAppend.join(',');
    }

    buildOrderBy += thenByIsChecked ? ' DESC' : '';

    console.log("buildOrderBy::1",buildOrderBy);

    onValueSubmit(selectedNodeId, name, buildOrderBy, selectedCurrentTableValue, selectedColumns,
      isChecked, thenByIsChecked, selectedThenByColumns, showAdditionalinputlength);
    // Perform the submit action with the formData
    // ...


  };


  const handleThenByColumnChange = (event, index) => {
    const { value } = event.target;

    // Update the selectedThenByColumns state with the selected value
    const updatedColumns = [...selectedThenByColumns];
    updatedColumns[index] = value;
    setSelectedThenByColumns(updatedColumns);
  };


  const handleColumnChange = (event) => {
    const selectedColumnName = event.target.value;
    setSelectedColumns(selectedColumnName);
  };


  // Function to update the dynamic value
  const handleNameChange = (event) => {

    setName(event.target.value);
  };

  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setIsChecked(isChecked);
  };

  const handleThenByCheckboxChange = (event, index) => {
    const isChecked = event.target.checked;
    setThenByIsChecked((prevIsChecked) => ({
      ...prevIsChecked,
      [index]: isChecked,
    }));
  };


  const handleLinkClick = () => {
    // Perform any actions when the link is clicked
    // ...
  };

  const renderColumnOptions = () => {
    if (selectedCurrentTableValue) {
      const columnOptions = columnsDataValues.map((column) => {
        const parts = column.split('.');
        const displayValue = parts.length === 4 ? parts[3] : parts[1];
        return (
          <option key={column} value={column}>
            {displayValue}
          </option>
        );
      });

      // Add aliasColumn as an additional option, filtering out empty or null values
      if (aliasColumn && aliasColumn.length > 0) {
        aliasColumn
          .flat(Infinity) // Flatten the array to handle nested arrays of any depth
          .filter((value) => value !== "" && value !== null) // Filter out empty strings and null values
          .forEach((value, index) => {
            columnOptions.push(
              <option key={index} value={value}>
                {value}
              </option>
            );
          });
      }
      return columnOptions;
    }


    return null;
  };




  return (
    <div className="overlay">

      <div className="popup-datatable">
        <div className="popup-header">
          <h4 class='modal-title'>Tool Options</h4>
          <button className="close-button" onClick={onClose}>

            <span>&times;</span>
          </button>
        </div>
        <div className="datatable-content">
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="textbox">Name </label>
              <input type="text" value={name}
                className="form-control"
                onChange={handleNameChange}
                id="textbox" />
            </div>


            <div className="form-group">
              <label htmlFor="dropdown">Sort By</label>


              <select
                id="dropdown"
                className="form-control"

                value={selectedColumns}
                onChange={handleColumnChange}
              >
                {renderColumnOptions()}
              </select>

            </div>

            <div className="checkbox-container">
              <label>
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />
                Descending
              </label>
            </div>


            {renderAdditionalInputs()}
            <div className="form-group">
              <button type='button' className='btn btn-primary' onClick={handleAddAnotherClick}>
                Add Another
              </button>
            </div>

            <div className="form-group toolHelpLink">
              <a href="https://example.com" target="_blank" onClick={handleLinkClick}>
                How does this tool work?
              </a>
            </div>
          </div>
          <div className="modal-footer">
            <button type='button' onClick={handleRemoveTable} class='btn btn-danger remove'>Delete Tool</button>
            <button type='button' className='btn btn-primary ok' onClick={handleSubmit}>OK</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SortPopupComponent;
